module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAUVBMVEUAAABmZmZVVVVGRk9DQ1FGQVBFRU5CQlBGRk9ERFBFQU9FQk1EQU9DQ05CQk5EQk1DQU9DQ05DQk5CQU1DQk5CQk5DQk5CQU1CQU5CQU1CQU1K4MeYAAAAGnRSTlMABQwdJjM0NjdASllaXGxthYarwM7U6Orv+1olgGEAAADPSURBVDjL1ZPZEoIwDEXZV1sRynb+/0MtDmop4MQ3vS9t0jNJJk2C4A8UJUn0GVDthNXUqjMw1CMvjTo8YmJj3/qmLsu66e3VxHsmG6DLn1bRwZDt4gzM2nXomcGLFRrmauuqZsy2Lg3aD+77opFuvaaQrteO0e2EgnwPFaAcqKUP9lDQ0zrQRHME3ZickqB+AFY2s1rOxa7hXVQC5XLiaLFLSL6DztJd3HSiwmUtEDVT9C2HH3z1faJREQ2dP7754fjKFkG2UrLlFK75j+gOvwwYHO0UhTwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/tianjia@2x.png
// module id = D2cf
// module chunks = 96